import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { deleteCookieByName, getCookie } from '@auth/bp-pf-auth';
import { environment } from '../../../environments/environment';
import { PermissionService } from '../../modules/auth/services/permission.service';

export const authGuard: CanActivateFn = (route, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const permissionService = inject(PermissionService);

  const tenant = getCookie(`${environment.app_id}_tenant_code`) || route.paramMap.get('tenantcode') || '';
  const token = getCookie(`${tenant}_${environment.app_id}_access_token`);

  const wasLoggedIn = localStorage.getItem(`${tenant}_${environment.app_id}_wasLoggedIn`) === 'true';

  if (!token) {
    if (tenant) {
      //  Store returnUrl temporarily
      localStorage.setItem(`${tenant}_${environment.app_id}_returnUrl`, state.url);

      //  A stale original_state cookie from an earlier login attempt would otherwise
      //  take priority over the returnUrl query param and hijack the redirect target.
    //   deleteCookieByName(`${tenant}_${environment.app_id}_original_state`);
    }

    if (wasLoggedIn) {
      router.navigate(['/', tenant, 'logout'], { queryParams: { returnUrl: state.url } });
    } else {
      router.navigate(['/', tenant], { queryParams: { returnUrl: state.url } });
    }
    return false;
  }

  // Ensure permissions are loaded after login callback
  // (APP_INITIALIZER may have missed them if the token wasn't available at bootstrap)
  permissionService.ensureLoaded();

  if (tenant) {
    localStorage.removeItem(`${tenant}_${environment.app_id}_returnUrl`);
  }

  return true;
};
